<template>
  <img
    class="cs-icon-image"
    :src="icon"
    width="24"
    height="24"
    alt=""
    v-if="icon && (icon.startsWith('data:image') || icon.startsWith('/src'))"
  />
  <i :class="icon" v-on="$listeners" v-else-if="icon && icon.startsWith('el-icon')" />
  <i :class="['el-icon-', 'icon', icon]" v-on="$listeners" v-else-if="icon && icon.startsWith('i-')" />
  <svg class="cs-icon-comp cs-icon el-icon-" aria-hidden="true" v-on="$listeners" v-else>
    <use :xlink:href="iconName" />
  </svg>
</template>

<script lang="ts">
import { BaseComponent, Component, Prop } from './base'

@Component
export default class CsIcon extends BaseComponent {
  @Prop({ type: String })
  icon!: string

  get iconName() {
    return `#${this.icon}`
  }
}
</script>

<style lang="less">
.cs-icon-comp {
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 0;
  vertical-align: -0.15em;
  overflow: hidden;
}

.el-submenu,
.el-menu-item {
  .cs-icon {
    margin-right: 5px;
    width: 24px;
    height: 18px;
    fill: #909399;
    stroke: #909399;
    vertical-align: middle;
  }

  &.is-active {
    .cs-icon {
      fill: currentColor;
      stroke: currentColor;
    }
  }
}
</style>
